import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../Checkbox';
import { type ChipButtonItem } from '../../types/types';
import { ChipItem } from '../../styles';

type MultiSelectItemsProps = {
  items: ChipButtonItem[];
  selectedValues: string[];
  onChange?: (selectedValues: string[]) => void;
  children?: React.ReactNode;
  allowSelectAll?: boolean;
};

export const MultiSelectItems = ({
  items,
  selectedValues,
  onChange,
  children,
  allowSelectAll = false,
}: MultiSelectItemsProps) => {
  const { t } = useTranslation();

  return (
    <>
      {allowSelectAll && (
        <ChipItem key="select-all">
          <Checkbox
            checked={selectedValues.length === items.length}
            label={t('select.all')}
            value="select-all"
            fullWidth
            onChange={(checked: boolean) => {
              onChange?.(checked ? items.map((item) => item.value) : []);
            }}
          />
        </ChipItem>
      )}
      {items.map((item) => (
        <ChipItem key={item.value}>
          <Checkbox
            checked={selectedValues.includes(item.value)}
            label={item.label}
            value={item.value}
            fullWidth
            onChange={(checked: boolean) => {
              onChange?.(
                checked
                  ? [...new Set([...selectedValues, item.value])]
                  : selectedValues.filter((v) => v !== item.value),
              );
            }}
          />
        </ChipItem>
      ))}

      {children}
    </>
  );
};
